import { lazy } from 'react';

export default lazy(
  () =>
    import(
      /* webpackChunkName: "bid-entry-management" */
      './BidManagementHub'
    )
);
